<template>
        <v-card flat>
            <v-card-title>
      <h3>Realtime Data Feed</h3>
      <v-btn text icon color="grey lighten-1" @click="refresh"><v-icon>fas fa-sync</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fal fa-search"
        placeholder="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
          <v-data-table
              :items="endpointRTLogs"
              :loading="loading"
              :headers="headers"
              :footer-props="{'items-per-page-options': numRowsPerPage}"
              :options.sync="pagination"
              :server-items-length="totalItems"
              class="elevation-1"
            >
          <template slot="items" slot-scope="props">
            <td>{{formatDateTime(props.item.receivedTime)}}</td>
            <td>
              <v-flex pl-1 pr-1>
              <v-textarea readonly v-model="props.item.value" label="" style="font-size:small"></v-textarea>
              </v-flex>
            </td>
            <td><v-btn text icon @click="doCopy(props.item.value)"><v-icon>file_copy</v-icon></v-btn></td>
          </template>
          </v-data-table>
        </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
export default {
  props: {
    srcIdFilter: [Number, String],
    rowsPerPage: {
      type: Number,
      default: 10
    }
  },
  async mounted () {
    this.loading = true
    await this.$store.dispatch('collectors/getEndpointRTLogs', {endpointId: this.srcIdFilter, pageSize: this.rowsPerPage, pageNumber: 1})
    this.totalItems = this.endpointRTLogTotal
    this.loading = false
  },
  updated() {
    this.totalItems = this.endpointRTLogTotal
  },
  computed: {
    ...mapGetters('collectors', {
        endpointRTLogs: 'getEndpointRTLogs',
        endpointRTLogTotal: 'getEndpointRTLogTotal'
    })
  },
  data() {
    return {
      loading: false,
      search: '',
      numRowsPerPage: [5,10,25],
      pagination : {rowsPerPage: this.rowsPerPage, totalItems: 0, search: ""},
      totalItems: 12,
      headers: [
        {text: 'Date', align: 'left', sortable: false, value:'receivedTime', width: '15%'},
        {text: 'Log', align: 'left', sortable: false, value:'value', width: '80%'},
        {text: 'Actions', align: 'left', sortable: false, value: 'actions', width: '5%'}
        ]
    }
  },
  watch: {
    pagination: {
      async handler () {
        const { page, rowsPerPage } = this.pagination
        this.loading = true
        await this.$store.dispatch('collectors/getEndpointRTLogs',
                { endpointId: this.srcIdFilter,
                  pageSize: rowsPerPage,
                  pageNumber: page})
        this.loading = false
      },
      deep: true
    }
  },
  methods: {
    async refresh() {
      this.loading = true
      await this.$store.dispatch('collectors/getEndpointRTLogs', {endpointId: this.srcIdFilter, pageSize: this.pagination.rowsPerPage, pageNumber: 1})
      this.loading = false
    },
    formatDateTime(val) {
      return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
    },
    doCopy(val) {
      this.$copyText(val).then(() => {
        //alert('copied')
      })
    }
  }
}
</script>
<style scope>
.alarm {
  color: red!important;
}
</style>
